$(function () {
    var el = $("#property-carousel");
    var carouselOptions = {
        margin: 5,
        nav: false,
        dots: true,
        lazyLoad: true,
        items: 1
    };
    
    //init
    el.owlCarousel(carouselOptions);
});
